import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { setNotificationAction } from 'store/common/actions'
import { ErrorPage } from '@centra/centra-ui'

const OopsPage = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setNotificationAction(null))
  }, [])

  return <ErrorPage errorType={'500'} view={'white'} />
}

export default OopsPage
